import apiRequestCommon from './index'

export default {
  path: '/v1/ss_info/ss',

  async get (id) {
    await window.callNativeHTTPX()
    const headersParam = {
      'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
      'HTTP-X-DAPP-USERID': window.DAPP_USERID,
      'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
    }
    return apiRequestCommon.get(`${this.path}/${id}`, {
      headers: headersParam
    })
  }
}
